import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import images from '_images';

// Style
const CTAContainer = styled.div`
position: absolute;
top: -52px;
right: 25px;
`;

const Share = styled.button`
background-color: transparent;
background-image: url(${images.materialDetails.share});
background-position: center;
background-repeat: no-repeat;
background-size: 63%;

width: 38px;
height: 38px;

border: none;
cursor: pointer;
padding: 0;
margin-right: 15px;
border: 2px solid #378B87;
border-radius: 50%;
`;

const Rp = styled.button`
background-color: transparent;
background-image: url(${images.materialDetails.rp});
background-position: center;
background-repeat: no-repeat;
background-size: 64%;

width: 38px;
height: 38px;

border: none;
cursor: pointer;
padding: 0;
margin: 0;
border: 2px solid #378B87;
border-radius: 63%;
`;
// End of style
const CTAofCMS = () => {
  const history = useHistory();

  return (
    <CTAContainer>
      <Share onClick={() => history.push('/')} aria-label="share information" />
      <Rp onClick={() => history.push('/report-problem')} aria-label="report a problem" />
    </CTAContainer>
  );
};

export default CTAofCMS;
